import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-17',
  templateUrl: './dpto17.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto17Component extends DepartmentBase {
  municipalities = [{
    "id": 319,
    "code": "17001",
    "name": "Manizales",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 320,
    "code": "17013",
    "name": "Aguadas",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 321,
    "code": "17042",
    "name": "Anserma",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 322,
    "code": "17050",
    "name": "Aranzazu",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 323,
    "code": "17088",
    "name": "Belalc\u00e1zar",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 324,
    "code": "17174",
    "name": "Chinchin\u00e1",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 325,
    "code": "17272",
    "name": "Filadelfia",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 326,
    "code": "17380",
    "name": "La Dorada",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 327,
    "code": "17388",
    "name": "La Merced",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 328,
    "code": "17433",
    "name": "Manzanares",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 329,
    "code": "17442",
    "name": "Marmato",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 330,
    "code": "17444",
    "name": "Marquetalia",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 331,
    "code": "17446",
    "name": "Marulanda",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 332,
    "code": "17486",
    "name": "Neira",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 333,
    "code": "17495",
    "name": "Norcasia",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 334,
    "code": "17513",
    "name": "P\u00e1cora",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 335,
    "code": "17524",
    "name": "Palestina",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 336,
    "code": "17541",
    "name": "Pensilvania",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 337,
    "code": "17614",
    "name": "Riosucio",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 338,
    "code": "17616",
    "name": "Risaralda",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 339,
    "code": "17653",
    "name": "Salamina",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 340,
    "code": "17662",
    "name": "Saman\u00e1",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 341,
    "code": "17665",
    "name": "San Jos\u00e9",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 342,
    "code": "17777",
    "name": "Sup\u00eda",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 343,
    "code": "17867",
    "name": "Victoria",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 344,
    "code": "17873",
    "name": "Villamar\u00eda",
    "state": "1",
    "department_code": "17"
  }, {
    "id": 345,
    "code": "17877",
    "name": "Viterbo",
    "state": "1",
    "department_code": "17"
  }]
}
